import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";

import { Page, IconButton, StyledLink } from "components/support";

import Dropzone from "./dropzone";
import Settings from "./settings";
import Queue from "./queue";

export default class BatchView extends Component {
  constructor(props) {
    super(props);
    this.presenter = props.presenter;
    this.router = props.transition.router;
  }

  onFileSelect = files => this.presenter.onFileSelect(files[0]);

  onChangeSettings = (header, value) =>
    this.presenter.onChangeSettings(header, value);

  onSubmitSettings = () => this.presenter.onSubmitSettings();

  onStartQueue = rows => this.presenter.onStartQueue(rows);

  onStopQueue = () => this.presenter.onStopQueue();

  onChangeQueue = ({ field, value, name }) =>
    this.presenter.onChangeQueue({ field, value, name });

  render() {
    const { presenter, viewModel } = this.props;
    const { upload, csv, settings, queue } = viewModel;
    const { status } = upload;
    const { headers, parsedRows } = csv;
    const { columns, submitted } = settings;
    const { started, errors, stages, progress, pagination } = queue;

    return (
      <Page>
        <Row>
          <Col xs={12}>
            <Row>
              <Col xs={10}>
                <Typography type="display1" className="pb-sm">
                  <IconButton
                    icon="arrow_back"
                    onClick={() => presenter.onGoBack()}
                  />
                  Importação de Produtos
                </Typography>
              </Col>
              <Col xs={2}>
                <StyledLink
                  style={{ float: "right" }}
                  label="Modelo"
                  accent
                  href={`https://plug-and-play-${process.env.REACT_APP_ENV}-storage.s3.amazonaws.com/planilhas/planilha-modelo-cadastro-produto.csv`}
                  target="_blank"
                ></StyledLink>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Dropzone onFileSelect={this.onFileSelect} status={status} />
          </Col>
        </Row>
        {status === "valid" && (
          <Row>
            <Col xs={12}>
              <Settings
                columns={columns}
                headers={headers}
                onChange={this.onChangeSettings}
                onSubmit={this.onSubmitSettings}
              />
            </Col>
          </Row>
        )}
        {status === "valid" && columns.length > 0 && submitted && (
          <Row>
            <Col xs={12}>
              <Queue
                started={started}
                headers={headers}
                columns={columns}
                errors={errors}
                stages={stages}
                rows={parsedRows}
                onStart={this.onStartQueue}
                onStop={this.onStopQueue}
                progress={progress}
                page={pagination.page}
                perPage={pagination.perPage}
                onPageChange={page => this.presenter.onPageChange(page)}
                onChange={(index, fieldName, value) =>
                  this.presenter.onFieldChange(index, fieldName, value)
                }
              />
            </Col>
          </Row>
        )}
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/batch.view.js